import { createContext, useContext } from 'react'
import type { RefObject } from 'react'
import type { ScrollSpyItem } from './types'

export interface ScrollSpyContextValue {
  activeId: string
  items: ScrollSpyItem[]
  registerSection: (key: string, el: HTMLElement | null) => void
  scrollToSection: (key: string) => void
  scrollContainerRef: RefObject<HTMLDivElement | null>
}

export const ScrollSpyContext = createContext<ScrollSpyContextValue | null>(
  null
)

export const useScrollSpyContext = (): ScrollSpyContextValue => {
  const ctx = useContext(ScrollSpyContext)
  if (!ctx) {
    throw new Error(
      'ScrollSpyLayout.Sidebar/Content/Section must be used within <ScrollSpyLayout>'
    )
  }
  return ctx
}
